import feathersClient, {
  makeServicePlugin,
  BaseModel
} from '../../feathers-client'

class ChangeLog extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'ChangeLog'
  // Define default properties here
  static instanceDefaults() {
    return {
      finding: {},
      headers: {},
      kind: '',
      timestamp: null,
      user: null,
      userName: '',
      userType: ''
    }
  }
  static setupInstance(data) {
    return data
  }
}
const servicePath = 'change-log'
const servicePlugin = makeServicePlugin({
  Model: ChangeLog,
  service: feathersClient.service(servicePath),
  servicePath,
  debug: true
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
